module.exports = __webpack_public_path__ + "static/media/logo_black.2989506b.png";